import React, { Fragment, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './components/Sidebar'

const AppLayout = () => {
    return (
        <Fragment>
            <Sidebar appName={process.env.REACT_APP_NAME} />
            <main className="main-content">
                <div className="container-fluid content-inner p-4 pb-0">
                    <div className="page-content">
                        <Suspense fallback={<div className="react-load"></div>}>
                            <Outlet />
                        </Suspense>
                    </div>
                </div>
            </main>
        </Fragment>
    )
}

export default AppLayout
